/**
 * The external dependencies.
 */
import React from 'react';
/**
 * The internal dependencies.
 */
import logo from '../../../assets/images/logo-small.png';
import logosoh from '../../../assets/images/logo-small-soh.png';
import logowim from '../../../assets/images/logo-small-wim.png';

const getLogo = () => {
    switch (process.env.CLIENT) {
        case 'soh':
            return logosoh;
        case 'wim':
            return logowim;
        default:
            return logo;
    }
}

const Logo = () => (
    <img src={getLogo()} alt="Customer Logo"/>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/dashboard/header/logo.js